import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-visualizador-pdf',
  templateUrl: './visualizador-pdf.component.html',
  styleUrls: ['./visualizador-pdf.component.scss']
})
export class VisualizadorPdfComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  arquivo;
  nomeArquivo;
  aceite;
  concordar = false;
  eliminarModal = false;

  constructor(private router: Router, private route: ActivatedRoute,
    private viewContainerRef: ViewContainerRef,
    public dialogRef: MatDialogRef<VisualizadorPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    // if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.arquivo) {
    //   this.arquivo = this.router.getCurrentNavigation().extras.state.arquivo;
    // }

    // if (this.route.snapshot.paramMap.get('arquivo')) {
    //   this.arquivo = decodeURI(this.route.snapshot.paramMap.get('arquivo'));
    // }

    this.arquivo = this.data.arquivo;
    this.nomeArquivo = this.data.nomeArquivo;
    this.aceite = this.data.aceite;
    this.eliminarModal = this.data.eliminarModal;
  }

  fechar() {

    if (this.eliminarModal) {
      this.viewContainerRef
        .element
        .nativeElement
        .parentElement
        .removeChild(this.viewContainerRef.element.nativeElement);

      this.dialogRef.close(true);
    } else {
      this.dialogRef.close();
    }
  }

  aceitar() {
    this.dialogRef.close(true);
  }


}
